/* main.js — site chrome behaviour (vanilla, no dependencies)
   Concatenated into built/could.js by gulp. Replaces the former
   library-based burger toggle and responsive-embed helper.
   could.js loads just before </body>, so the DOM is already parsed. */

(function () {
    'use strict';

    /* --- Mobile menu (burger) toggle --- */
    var burger = document.querySelector('.gh-burger');
    var body = document.body;

    function closeMenu() {
        body.classList.remove('gh-head-open');
        if (burger) {
            burger.setAttribute('aria-expanded', 'false');
        }
    }

    if (burger) {
        burger.addEventListener('click', function () {
            var open = body.classList.toggle('gh-head-open');
            burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && body.classList.contains('gh-head-open')) {
                closeMenu();
            }
        });
    }

    /* --- Responsive embeds ---
       Give raw iframes inside post content a fluid aspect-ratio.
       Skip Ghost's Koenig embed cards — those are handled by ported CSS. */
    var iframes = document.querySelectorAll('.gh-content iframe');

    Array.prototype.forEach.call(iframes, function (iframe) {
        if (iframe.closest('.kg-embed-card')) {
            return;
        }

        var w = parseFloat(iframe.getAttribute('width'));
        var h = parseFloat(iframe.getAttribute('height'));
        var ratio = (w && h) ? (w + ' / ' + h) : '16 / 9';

        iframe.style.aspectRatio = ratio;
        iframe.style.width = '100%';
        iframe.style.height = 'auto';
    });
})();
